//English
export default {
	touch: "Use two fingers to move the map",
	scroll: "Use ctrl + scroll to zoom the map",
	scrollMac: "Use \u2318 + scroll to zoom the map"
};
